import { render, staticRenderFns } from "./ChecklistTab.vue?vue&type=template&id=4a4b8bea&scoped=true&"
import script from "./ChecklistTab.vue?vue&type=script&lang=js&"
export * from "./ChecklistTab.vue?vue&type=script&lang=js&"
import style0 from "./ChecklistTab.vue?vue&type=style&index=0&id=4a4b8bea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4b8bea",
  null
  
)

export default component.exports